import { createSlice, createAction } from '@reduxjs/toolkit';

export const init = createAction('/sequentialModal/INIT', (steps: number) => {
    return {
        payload: steps
    }
});

export const reset = createAction('/sequentialModal/RESET');
export const nextStep = createAction('/sequentialModal/NEXT_STEP');
export const previousStep = createAction('/sequentialModal/PREVIOUS_STEP');


const sequentialModal = createSlice({
    name: 'sequentialModal',
    initialState: {
        numberOfSteps: 0,
        currentStep: 0
    },
    reducers: {},
    extraReducers(builder) {
        builder.addMatcher(init.match, (state, { payload }) => {
            state.numberOfSteps = payload;
        });

        builder.addMatcher(nextStep.match, (state, action) => {
            if(state.currentStep + 1 <= state.numberOfSteps) {
                state.currentStep++;
            } else {
                state.currentStep = 0;
            }
        });

        builder.addMatcher(previousStep.match, (state, action) => {
            if(state.currentStep - 1 > 0) {
                state.currentStep--;
            } else {
                state.currentStep = 0;
            }
        });

        builder.addMatcher(reset.match, (state, action) => {
            state.currentStep = 0;
        });
    },
});

export default sequentialModal;